<template>
  <svg :width="width" :height="height" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_11032_21719)">
      <path
        d="M15.5 9.5C12.3306 10.2631 9.61562 12.7694 7.98125 14.0894C7.50975 13.6525 7.01284 13.2439 6.49312 12.8656C4.22062 11.2056 1.5 11 1.5 11C1.5 11 2.21063 14.2206 4.085 15.9894C2.21063 17.7588 1.5 20.9794 1.5 20.9794C1.5 20.9794 4.22062 20.7738 6.49312 19.1138C7.00845 18.7388 7.50118 18.3337 7.96875 17.9006C9.6 19.2219 12.3275 21.7344 15.5 22.5L14.5 26C16.9644 25.5831 19.4287 23.7806 20.42 22.9844C28.5 22.625 31.5 17.4375 31.5 16C31.5 14.625 28.5 9.375 20.4444 9.01688C19.47 8.23625 16.985 6.42 14.5 6L15.5 9.5Z"
        :stroke="color"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M26.5 15.999C27.0523 15.999 27.5 15.5513 27.5 14.999C27.5 14.4467 27.0523 13.999 26.5 13.999C25.9477 13.999 25.5 14.4467 25.5 14.999C25.5 15.5513 25.9477 15.999 26.5 15.999Z"
        :fill="color"
      />
      <path
        d="M24.1491 22.25C23.0472 20.3514 22.4668 18.1952 22.4668 16C22.4668 13.8048 23.0472 11.6486 24.1491 9.75"
        :stroke="color"
        stroke-width="2"
        stroke-miterlimit="20"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_11032_21719">
        <rect width="32" height="32" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'FishIcon',
  props: {
    width: {
      type: Number,
      default: 33,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
